
var NavController = require('./nav-controller');
var NavFactory = require('./nav-factory');
var ProfileHelper = require('../profile/profile-helper');
var darklaunch = require('src/interlock/no-ui/utils/darklaunch/darklaunch');
var firstDropdown = true;

$('#nav .nav-link:not(.linkout)').on('click', function(e) {

    e.preventDefault();
    var isActive = $(this).hasClass('active');
    var show = $(this).data('show');
    $('#nav .nav-link').removeClass('active');
    if(!isActive && show) {
        $('.nav-container .content').addClass('hidden');
        $(show).removeClass('hidden');
        $(this).addClass('active');
        $('.nav-container.collapse').collapse('show');
        if(darklaunch.storyEnabled('TMT-207')) {
            if(firstDropdown) {
                firstDropdown = false;
            } else {
                NavController.fireGlobalNavImpressionTracking($(this).data('show'));
            }
        } else {
            NavController.fireGlobalNavImpressionTracking($(this).data('show'));
        }
    } else {
        $('.nav-container.collapse').collapse('hide');
    }
    NavFactory.resetSelected();
    $('#nav_container .makes').removeClass('hidden');
    $('#nav_container .models').addClass('hidden');
    $('#nav_container .years').addClass('hidden');
});

// make anchor clicks
$('#nav_container .makes .list a').on('click', function (e) {
    NavController.makeAnchorSelect(this, e);

    NavController.fireGlobalNavImpressionTracking($(this).data('parentId'));

});

// nav container header...
$('#nav_container .nav-header .selected.make').on('click', function (e) {
    NavController.makeHeaderSelect(this, e);

    NavController.fireGlobalNavImpressionTracking($(this).data('parentId'));
});

$('#nav_container .nav-header .selected.model').on('click', function (e) {
    NavController.modelHeaderSelect(this, e);

    NavController.fireGlobalNavImpressionTracking($(this).data('parentId'));
});

// cars for sale...

$('#nav_cars_for_sale .togglable .show').on('click', function(e) {
    e.preventDefault();
    var togglableId = $( this ).data('togglableId');
    $(this).addClass('hidden');
    $(this).siblings('.hidden').removeClass('hidden');
    if($(this).hasClass('less')) {
        // toggle show less
        $(togglableId).find('.col-xs-3:odd').hide();
        $(togglableId).removeClass('col-xs-10').addClass('col-xs-5');
        $(togglableId).find('.col-xs-3').removeClass('col-xs-3').addClass('col-xs-6');
        $('#nav_cars_for_sale .togglable-column:not('+togglableId+')').delay(150).show(0);
    } else {
        // toggle show all
        $('#nav_cars_for_sale .togglable-column:not('+togglableId+')').delay(100).hide();
        $(togglableId).removeClass('col-xs-5').addClass('col-xs-10');
        $(togglableId).find('.col-xs-6').removeClass('col-xs-6').addClass('col-xs-3').delay(100).fadeIn();
    }
});

// research carousel
$('#nav_research .nav-research-carousel-arrow').on('click', function(e) {
    e.preventDefault();
    var navResearchCarousel = $('#nav-research-carousel');
    $(this).hide();
    if($(this).hasClass('left')) {
        $(this).siblings('.nav-research-carousel-arrow.right').show();
        navResearchCarousel.carousel(0);
    } else {
        $(this).siblings('.nav-research-carousel-arrow.left').show();
        navResearchCarousel.carousel(1);
    }
});

ProfileHelper.on('signIn', function(user) {
    var nav = $('#nav');
    nav.find('a[data-target="#sign-in-drawer"]').css('display', 'none');
    nav.find('#user-menu-email').text(user.email);
    nav.find('#user-menu').css('display', 'inline-block');
});

ProfileHelper.on('signOut', function() {
    var nav = $('#nav');
    nav.find('#user-menu').css('display', 'none');
    nav.find('a[data-target="#sign-in-drawer"]').css('display', 'inline-block');
});


$('#sign-in-drawer, #sign-up-drawer, #forgot-password-drawer').
find('.close-drawer, a[data-target="#forgot-password-drawer"], a[data-target="#sign-in-drawer"], a[data-target="#sign-up-drawer"]')
    .on('click', function() {
        var form = $('#sign-in-drawer, #sign-up-drawer, #forgot-password-drawer');
        var email = $('#sign-in-form input[name=email]').val();
        form.find('form').find('input').val('');
        form.find('.has-success, .has-danger').removeClass('has-danger').removeClass('has-success');
        form.find('.form-control-danger, .form-control-success').removeClass('form-control-danger').removeClass('form-control-success');
        form.find('.text-danger').text('');
        $('#forgot-password-form input[name=email]').val(email);
    });



//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav/nav.js
// module id = 75
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14